<template>
  <v-layout row>
    <v-flex
      xs12
      sm10
      offset-sm1
      md8
      offset-md2
      lg6
      offset-lg3
      xl6
      offset-xl3
      v-if="!isExpo && !areaListMode"
    >
      <v-card flat>
        <v-card-text>
          <div>
            <div class="select-outlet">
              PLEASE SELECT OUTLET:
            </div>
            <div
              v-for="(restaurant, index) in filteredRestaurants"
              :key="index"
              class="outlets mt-4 mb-3"
            >
              <div>
                <h4
                  @click="setOutlet(restaurant)"
                >
                  {{ restaurant.Name }}
                  <span>
                    ({{ restaurantDistance(restaurant) }})
                  </span>
                </h4>
                </div>
                <img
                  :src="myPhoto(restaurant.ID)"
                  :style="myPhotoStyle"
                  @click="setOutlet(restaurant)"
                  @error="imageLoadError"
                />
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex
      xs12
      sm12
      md12
      lg10
      offset-lg1
      xl8
      offset-xl2
      v-else
    >
      <v-card flat>
        <v-card-text>
          <div>
            <div class="select-outlet">
              {{ $t('select_outlet') }}:
            </div>
            <v-layout
              row
              wrap
            >
              <v-flex
                d-flex
                xs12
                sm6
                md4
                lg3
                xl2
                v-for="(outlet, index) in filteredRestaurants"
                :key="index"
                class="my-3"
              >
                <outlet-selector :name-suffix="' (' + restaurantDistance(outlet) + ')'" :outlet="outlet.config" />
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters } from 'vuex'
import OutletSelector from '~/components/OutletSelector'

export default {
  props: ['is_expo'],
  name: 'area1',
  layout: 'group',
  metaInfo () {
    return { title: 'Area' }
  },
  components: {
    'outlet-selector': OutletSelector
  },
  computed: {
    ...mapGetters('area', [
      'selectedArea', 'selectedAreaMode', 'isExpo', 'areaListMode'
    ]),
    ...mapGetters('config', [
      'rid', 'pictures', 'photo', 'theme',
    ]),
    ...mapGetters('cart', [
      'cartQty'
    ]),
    restaurants () {
      return this.selectedArea.restaurants
    },
    filteredRestaurants () {
      var byDistance = this.selectedArea.restaurants.slice(0);
      byDistance.sort(function(a,b) {
        return a.distance - b.distance;
      });
      return byDistance
    },
    myPhotoStyle() {
      return {
        width: '100%',
      }
    }
  },
  methods:{
    myPhoto (rID) {
      return 'https://gemscms.aptsys.com.sg/gems_images/Webapp/' + rID + '/bg_img.jpg'
    },
    imageLoadError (event) {
      event.target.src = window.config.sharedPictures + 'sample_bg.jpg'
    },
    restaurantDistance (r) {
      if (r.distance) return r.distance/1000 + ' KM'
      else if (r.distance === 0) return 0 + 'KM'
      return '--'
    },
    setOutlet (restaurant) {
      const rID = restaurant.ID;
      const gID = restaurant.GroupID;
      const iOrderVersion = restaurant.config.iorder_version;

      // dine_mode, 1:takeaway, 2:delivery
      if (iOrderVersion == 2) {
        let dineMode = 0;
        if (this.selectedAreaMode.isTakeaway) {
          dineMode = 1;
        } else if (this.selectedAreaMode.isDelivery) {
          dineMode = 2;
        }

        window.location.href=`https://iorder2.aptsys.com.sg/${gID}/${rID}/menu?dine_mode=${dineMode}`;
        return;
      }

      this.$bus.$emit('showFullLoading', true)
      this.$store.dispatch('changeGroup', gID)
      this.$store.dispatch('changeOutlet', rID)
      this.$store.dispatch('config/setModeSelected')
      this.$router.push({ name: 'menu', params: { gid: gID, rid: rID }})
    }
  },
  async beforeMount () {
    await this.$store.dispatch('fetchAreas')

    if (this.selectedArea) {
      await this.$store.dispatch('area/setAreaListMode',this.selectedArea.area_list_mode)
    }

    if (!this.is_expo || this.areaListMode) {
      this.$store.dispatch('resetSelectedArea')
      await this.$store.dispatch('area/setSelectedArea', parseInt(this.$route.params.id))
    } else {
      await this.$store.dispatch('area/setIsExpo')
      await this.$store.dispatch('area/hidePostalCodeDialog')
    }
  }
}
</script>

<style scoped>
  .select-outlet {
    font-size: 17px;
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/pages/area1.vue